import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/ServicePage";
import { AUTOMACAO_PAGES } from "@/lib/automacao-pages";

const data = AUTOMACAO_PAGES["atendimento-para-alto-volume-de-contatos"];

export const Route = createFileRoute("/atendimento-para-alto-volume-de-contatos")({
  head: () => ({
    meta: [
      { title: data.seoTitle },
      { name: "description", content: data.seoDescription },
      { property: "og:title", content: data.seoTitle },
      { property: "og:description", content: data.seoDescription },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.svgmultimidia.com.br/atendimento-para-alto-volume-de-contatos" },
    ],
    links: [{ rel: "canonical", href: "https://www.svgmultimidia.com.br/atendimento-para-alto-volume-de-contatos" }],
  }),
  component: () => <ServicePage {...data.page} />,
});
